export default __webpack_public_path__ + "static/media/CanaraBank.603a1bbe.png";